import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

// declare global {
//   interface Window {
//     AdvancedMarkerElement: any;
//     initAutocomplete: () => void;
//   }
// }

@Component({
  selector: 'app-maps-location-dialog',
  templateUrl: './maps-location-dialog.component.html',
  styleUrl: './maps-location-dialog.component.scss',
})
export class MapsLocationDialogComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('searchInput') searchElementRef!: ElementRef;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  userId: string = null;
  center: google.maps.LatLngLiteral = { lat: 28.7041, lng: 77.1025 };
  zoom: number = 8;
  coordinates: string = null;
  address: string = null;
  returnCoordinates: {
    coordinates: string;
    lat: any;
    lng: any;
    address: string;
  };
  response: string = null;

  markerPosition: google.maps.LatLngLiteral = {
    lat: 28.7041,
    lng: 77.1025,
  };

  markerOptions: google.maps.marker.AdvancedMarkerElementOptions = {
    gmpDraggable: true,
  };
  // Map control objects
  private autocomplete: google.maps.places.Autocomplete;
  private geocoder: google.maps.Geocoder;
  private placesService: google.maps.places.PlacesService;

  private screenSubscription: Subscription;
  isShowMap = false;

  constructor(
    private screen: AumyeResponsiveScreenService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngZone: NgZone,
    private encryptionService: EncryptionService
  ) {
    let decryptedUserData = this.encryptionService.decrypt(
      localStorage.getItem('UserDetails')
    );
    this.userId = decryptedUserData.UserID;
    let fullName =
      decryptedUserData.FirstName + ' ' + decryptedUserData.LastName;

    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    // (async () => {
    //   const { AdvancedMarkerElement } = (await google.maps.importLibrary(
    //     'marker'
    //   )) as google.maps.MarkerLibrary;
    //   window.AdvancedMarkerElement = AdvancedMarkerElement;
    // })();
  }
  async ngOnInit(): Promise<void> {
    try {
      // Initialize Google Maps libraries
      const { AdvancedMarkerElement } = (await google.maps.importLibrary(
        'marker'
      )) as google.maps.MarkerLibrary;
      window.AdvancedMarkerElement = AdvancedMarkerElement;

      // Initialize geocoder
      this.geocoder = new google.maps.Geocoder();
    } catch (error) {
      console.error('Error initializing Google Maps:', error);
    }
    if (window.google && window.google.maps && window.google.maps.places) {
      this.initPlacesAutocomplete();
    } else {
      window.addEventListener('load', () => {
        this.initPlacesAutocomplete();
      });
    }
  }

  ngAfterViewInit(): void {
    // Setup autocomplete after view is fully initialized
    // this.initPlacesAutocomplete();
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    if (this.screenSubscription) {
      this.screenSubscription.unsubscribe();
    }
  }

  initPlacesAutocomplete(): void {
    // Ensure the input element exists
    if (!this.searchElementRef || !this.searchElementRef.nativeElement) {
      console.error('Search input element not found');
      return;
    }

    // Make sure the Places library is loaded
    if (!google.maps.places) {
      console.error('Google Maps Places library not loaded');
      return;
    }

    try {
      // Create placeholder DIV for PlacesService (required)
      const placesDiv = document.createElement('div');
      document.body.appendChild(placesDiv);
      this.placesService = new google.maps.places.PlacesService(placesDiv);
      // Initialize autocomplete with expanded options
      this.autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['geocode', 'establishment'],
          // Uncomment and set bounds if you want to prioritize locations in a specific area
          // bounds: new google.maps.LatLngBounds(
          //   new google.maps.LatLng(28.4, 76.8), // Southwest corner
          //   new google.maps.LatLng(29.0, 77.4)  // Northeast corner
          // ),
          componentRestrictions: { country: 'in' }, // Limit to India - adjust as needed
          fields: [
            'address_components',
            'geometry',
            'name',
            'formatted_address',
            'place_id',
          ],
        }
      );
      this.isShowMap = true;
      // Add place_changed listener
      this.autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // Get the place details from the autocomplete object
          const place = this.autocomplete.getPlace();
          console.log('Place selected:', place);

          if (!place.geometry || !place.geometry.location) {
            console.warn('Place contains no geometry');
            return;
          }

          // Update map and marker position
          this.updateMapPosition(
            place.geometry.location.lat(),
            place.geometry.location.lng(),
            place.formatted_address || 'Selected location'
          );
        });
      });

      console.log('Autocomplete initialized successfully');
    } catch (error) {
      console.error('Error initializing Places Autocomplete:', error);
    }
  }

  performSearch(): void {
    const query = this.searchElementRef?.nativeElement.value;
    if (!query) return;

    console.log('Performing search for:', query);

    // Use the Places API TextSearch for better results
    const request = {
      query: query,
      fields: ['name', 'geometry', 'formatted_address'],
    };

    this.placesService.textSearch(request, (results, status) => {
      this.ngZone.run(() => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          results &&
          results.length > 0
        ) {
          const place = results[0];
          console.log('Search found place:', place);

          if (place.geometry && place.geometry.location) {
            this.updateMapPosition(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              place.formatted_address || place.name || 'Selected location'
            );
          }
        } else {
          console.warn('Place search was not successful:', status);

          // Fallback to geocoder if places search fails
          this.geocoder.geocode({ address: query }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results[0]) {
              const location = results[0].geometry.location;

              this.updateMapPosition(
                location.lat(),
                location.lng(),
                results[0].formatted_address
              );
            } else {
              console.warn('Geocode was not successful:', status);
              alert('Location not found. Please try a different search term.');
            }
          });
        }
      });
    });
  }

  currentLocation(): void {
    if (!navigator.geolocation) {
      window.alert('Geolocation is not supported by this browser');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        // Get address for the current location
        this.reverseGeocode(lat, lng);
      },
      (error) => {
        console.error('Error getting location:', error);
        window.alert(`Error getting location: ${error.message}`);
      },
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  }

  onMarkerDragEnd(event: any): void {
    if (!event.latLng) return;

    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    // Get address for the new marker position
    this.reverseGeocode(lat, lng);
  }

  private reverseGeocode(lat: number, lng: number): void {
    const latLng = new google.maps.LatLng(lat, lng);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      this.ngZone.run(() => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const address = results[0].formatted_address;
          this.updateMapPosition(lat, lng, address);

          // Update the search input with the found address
          if (this.searchElementRef) {
            this.searchElementRef.nativeElement.value = address;
          }
        } else {
          console.warn('Geocoder failed:', status);
          this.updateMapPosition(lat, lng, 'Address not found');
        }
      });
    });
  }

  private updateMapPosition(lat: number, lng: number, address: string): void {
    // Update marker and center
    this.markerPosition = { lat, lng };
    this.center = { lat, lng };
    this.zoom = 17;

    // Update response data
    this.address = address;
    this.coordinates = JSON.stringify(this.markerPosition);

    this.returnCoordinates = {
      coordinates: this.coordinates,
      lat: lat,
      lng: lng,
      address: this.address,
    };

    this.response = JSON.stringify(this.returnCoordinates);
  }
}
//   initializeAutocomplete(): void {
//     const autocomplete = new google.maps.places.Autocomplete(
//       this.searchElementRef.nativeElement,
//       {
//         types: ['geocode'], // Specify the types of place data to return
//         fields: ['address_components', 'geometry', 'icon', 'name', 'place_id'],
//       }
//     );
//     autocomplete.addListener('place_changed', () => {
//       this.ngZone.run(() => {
//         const place: google.maps.places.PlaceResult = autocomplete.getPlace();
//         if (place.geometry?.location) {
//           this.center = {
//             lat: place.geometry.location.lat(),
//             lng: place.geometry.location.lng(),
//           };
//           this.markerPosition = {
//             lat: place.geometry.location.lat(),
//             lng: place.geometry.location.lng(),
//           };
//           this.zoom = 15; // Adjust zoom level as needed
//         }
//       });
//     });
//   }
//   performSearch(): void {
//     const query = this.searchElementRef.nativeElement.value;
//     if (query) {
//       const searchBox = new google.maps.places.SearchBox(
//         this.searchElementRef.nativeElement
//       );
//       const places = searchBox.getPlaces();
//       if (places && places.length > 0) {
//         const place = places[0];
//         if (place.geometry?.location) {
//           this.center = {
//             lat: place.geometry.location.lat(),
//             lng: place.geometry.location.lng(),
//           };
//           this.markerPosition = {
//             lat: place.geometry.location.lat(),
//             lng: place.geometry.location.lng(),
//           };
//           this.zoom = 15; // Adjust zoom level as needed
//         }
//       }
//     }
//   }
//   address: string = null;
//   onMarkerDragEnd(event: any) {
//     console.log(event);

//     if (event.latLng) {
//       // Get the marker's new position (lat, lng)
//       this.markerPosition = {
//         lat: event.latLng.lat(),
//         lng: event.latLng.lng(),
//       };

//       // Convert lat/lng to address using Google Maps Geocoder
//       const geocoder = new google.maps.Geocoder();
//       const latLng = new google.maps.LatLng(
//         this.markerPosition.lat,
//         this.markerPosition.lng
//       );

//       geocoder.geocode({ location: latLng }, (results, status) => {
//         if (status === google.maps.GeocoderStatus.OK) {
//           if (results[0]) {
//             // Get the formatted address
//             const address = results[0].formatted_address;

//             // Log or store the address
//             console.log('Marker dropped at address:', address);

//             // You can also store the address in your model or send it to the server
//             this.address = address;
//             this.coordinates = JSON.stringify(this.markerPosition);
//             this.returnCoordinates = {
//               coordinates: this.coordinates,
//               lat: this.markerPosition.lat,
//               lng: this.markerPosition.lng,
//               address: this.address,
//             };
//             this.response = JSON.stringify(this.returnCoordinates);
//           } else {
//             console.log('No address found for this location.');
//           }
//         } else {
//           console.log('Geocoder failed due to:', status);
//         }
//       });

//       console.log('Marker dropped at position:', this.markerPosition);
//     }
//   }
//   currentLocation() {
//     if ('geolocation' in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           // Store the latitude and longitude
//           this.markerPosition = {
//             lat: position.coords.latitude,
//             lng: position.coords.longitude,
//           };

//           // Set the center to the current marker position
//           this.center = {
//             lat: this.markerPosition.lat,
//             lng: this.markerPosition.lng,
//           };

//           // Convert the coordinates to a JSON string
//           this.coordinates = JSON.stringify(this.markerPosition);

//           // Use Google Maps Geocoder to get the address from lat/lng
//           const geocoder = new google.maps.Geocoder();
//           const latLng = new google.maps.LatLng(
//             this.markerPosition.lat,
//             this.markerPosition.lng
//           );

//           // Reverse geocode to get the address
//           geocoder.geocode({ location: latLng }, (results, status) => {
//             if (status === google.maps.GeocoderStatus.OK && results[0]) {
//               this.address = results[0].formatted_address; // Get the address
//             } else {
//               this.address = 'Address not found'; // In case geocoding fails
//             }

//             // Prepare the response with coordinates and address
//             this.returnCoordinates = {
//               coordinates: this.coordinates,
//               lat: this.markerPosition.lat,
//               lng: this.markerPosition.lng,
//               address: this.address,
//             };

//             // Stringify the return coordinates object
//             this.response = JSON.stringify(this.returnCoordinates);

//             // Set the zoom level
//             this.zoom = 17;
//           });
//         },
//         (error) => {
//           window.alert(error.message); // Provide a meaningful error message
//         }
//       );
//     } else {
//       window.alert('Geolocation is not supported by this browser');
//     }
//   }

//   initAutocomplete() {
//     const input = document.getElementById('pac-input') as HTMLInputElement;
//     const searchBox = new google.maps.places.SearchBox(input);
//     searchBox.addListener('places_changed', () => {
//       const places = searchBox.getPlaces();
//       console.log(places);
//       if (places.length == 0) {
//         return;
//       }
//       if (places[0].geometry?.location) {
//         const place = places[0].geometry;
//         this.center = {
//           lat: place.location.lat(),
//           lng: place.location.lng(),
//         };
//         this.markerPosition = {
//           lat: place.location.lat(),
//           lng: place.location.lng(),
//         };
//         this.zoom = 15; // Adjust zoom level as needed
//       }
//     });
//   }
// }
